module.exports = __webpack_public_path__ + "static/media/mysticdiva_640.62ceffc4.jpg";